import {
    trigger,
    transition,
    style,
    query,
    group,
    animateChild,
    animate,
    keyframes,
} from '@angular/animations';

export const FadeInAnimation = trigger('routeAnimations', [
    // The '* => *' will trigger the animation to change between any two states
    // transition('* => *', [
    //     query(
    //         ':enter',
    //         [
    //             animate('600ms ease-in', keyframes([
    //                 style({opacity: 0, offset: 0}),
    //                 style({opacity: 1, offset: 1.0})
    //             ]))
    //         ],
    //         { optional: true }
    //     ),
    //     query(
    //         ':leave',
    //         // here we apply a style and use the animate function to apply the style over 0.3 seconds
    //         [style({ opacity: 1 }), animate('1s 0s ease-in-out', style({ opacity: 0 }))],
    //         { optional: true }
    //     ),
    //     query(
    //         ':enter',
    //         [style({ opacity: 0 }), animate('1s 0s ease-in-out', style({ opacity: 1 }))],
    //         { optional: true }
    //     )
    // ])

    transition('* => *', [

        style({ position: 'relative' }),
        
        query(':enter, :leave', [
            style({
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%'
            })
        ], { optional: true }),

        query(':enter', [
            style({
                opacity: '0',
                left: '30px'
            })
        ], { optional: true }),

        query(':leave', animateChild(), { optional: true }),

        group([
            query(':leave', [
                animate('200ms ease-out', style({
                    opacity: '0',
                    right: '-25px'
                }))
            ], { optional: true }),
            query(':enter', [
                animate('200ms 200ms ease-out', style({
                    opacity: '1',
                    left: '0px'
                }))
            ], { optional: true })
        ]),

        query(':enter', animateChild(), { optional: true }),
      ])
]);